<ng-container *ngIf="form">
  <div class="row w-100 mt-3 form-container">
    <ng-container *ngFor="let item of keys">
      <div [class]="item.css ? item.css : 'col-6'" class="mt-2">

        <!-- FORM SWITCH TYPE -->
        <ng-container [ngSwitch]="item?.type">

          <!-- CASE SELECT -->
          <ng-container *ngSwitchCase="'SELECT'">
            <mat-form-field class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <mat-select [id]="item.id ? item.id : item.controlName + '_form_item'"
                [formControlName]="item?.controlName">
                <ng-container *ngFor="let option of item.options">
                  <mat-option [value]="option.key" [disabled]="option.disabled">
                    {{ option.value }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error>{{ getErrorMessage(item?.controlName) }}</mat-error>
            </mat-form-field>
          </ng-container>

          <!-- CASE RADIO -->
          <ng-container *ngSwitchCase="'RADIO'">
            <div class="w-100" [formGroup]="form" *ngIf="!item.hidden">
              <h6 mat-label [innerHTML]="item?.label"></h6>
              <ng-container *ngIf="item?.wrapOptions">
                <br />
              </ng-container>
              <mat-radio-group class="vertical-radio-group" [formControlName]="item?.controlName">
                <ng-container *ngFor="let option of item.options">
                  <mat-radio-button [value]="option.key">{{ option.value }}</mat-radio-button>
                </ng-container>
              </mat-radio-group>
            </div>
          </ng-container>

          <!-- CASE MULTIPLE_SELECT -->
          <ng-container *ngSwitchCase="'MULTIPLE_SELECT'">
            <mat-form-field class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <mat-select [id]="item.id ? item.id : item.controlName + '_form_item'"
                [formControlName]="item?.controlName" multiple>
                <ng-container *ngFor="let option of item.options">
                  <mat-option [value]="option.key">
                    {{ option.value }}
                  </mat-option>
                </ng-container>
              </mat-select>
              <mat-error>{{ getErrorMessage(item?.controlName) }}</mat-error>
            </mat-form-field>
          </ng-container>

          <!-- CASE DATE -->
          <ng-container *ngSwitchCase="'DATEPICKER'">
            <mat-form-field class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <input [id]="item.id ? item.id : item.controlName + '_form_item'" [formControlName]="item.controlName" [max]="item.maxDate ? item.maxDate : null"
                [min]="item.minDate ? item.minDate : null" [matDatepicker]="picker" matInput />
              <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              <mat-error>{{ getErrorMessage(item?.controlName) }}</mat-error>
            </mat-form-field>
          </ng-container>

          <!-- CASE NUMBER -->
          <ng-container *ngSwitchCase="'NUMBER'">
            <mat-form-field class="w-100" [formGroup]="form" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <input [id]="item.id ? item.id : item.controlName + '_form_item'" [formControlName]="item.controlName"
                type="number" [attr.min]="item.numberMin || 0" [attr.max]="item.numberMax || 100" matInput>
            </mat-form-field>
          </ng-container>

          <!-- CASE TEXTAREA -->
          <ng-container *ngSwitchCase="'TEXTAREA'">
            <mat-form-field class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <textarea [formControlName]="item.controlName" [id]="item.id ? item.id : item.controlName + '_form_item'"
                style="min-height: 80px; height: auto" matInput>
                </textarea>
            </mat-form-field>
          </ng-container>

          <!-- CASE AUTOCOMPLETE -->
          <ng-container *ngSwitchCase="'AUTOCOMPLETE'">
            <mat-form-field class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <input matInput [id]="item.id ? item.id : item.controlName + '_form_item'"
                [formControlName]="item.controlName" [matAutocomplete]="matAuto">
              <mat-autocomplete #matAuto="matAutocomplete">
                <mat-option *ngFor="let item of filteredList | async" [value]="item.label"
                  (onSelectionChange)="setData(item)">
                  {{item.label}}
                </mat-option>
              </mat-autocomplete>
              <mat-error>{{ getErrorMessage(item?.controlName) }}</mat-error>
            </mat-form-field>
          </ng-container>

          <!-- CASE NEW LINE -->
          <ng-container *ngSwitchCase="'NEW_LINE'">
            <div [class]="item?.css" style="height: 2em;">
              <h6 style="padding-left: 1em;">{{ item?.label }}</h6>
            </div>
          </ng-container>

          <!-- CASE CHECKBOX -->
          <ng-container *ngSwitchCase="'CHECKBOX'">
            <div class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-checkbox [formControlName]="item.controlName" [id]="item.id ? item.id : item.controlName + '_form_item'">
                {{ item?.label }}
              </mat-checkbox>
            </div>
          </ng-container>

          <!-- CASE TOGGLE -->
          <ng-container *ngSwitchCase="'TOGGLE'">
            <div class="w-100 toggle-section" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-slide-toggle
                [formControlName]="item.controlName"
                [id]="item.id ? item.id : item.controlName + '_form_item'"
                color="primary"
                class="toggle-margin">
                {{ item?.label }}
              </mat-slide-toggle>
            </div>
          </ng-container>

          <!-- CASE BUTTON -->
           <ng-container *ngSwitchCase="'BUTTON'">
              <div class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
                <button mat-raised-button color="primary" (click)="item?.action()">{{ item?.label }}</button>
              </div>
          </ng-container>

          <!-- CASE TEXT INPUT -->
          <ng-container *ngSwitchDefault>
            <mat-form-field class="w-100" [formGroup]="form" appearance="outline" *ngIf="!item.hidden">
              <mat-label>{{ item?.label }}</mat-label>
              <input matInput [formControlName]="item.controlName" [id]="item.id ? item.id : item.controlName + '_form_item'" (input)="onInputChange($event, item)" (keyup.enter)="onKeyup()" (blur)="onInputBlur($event, item)">
              <mat-error>{{ getErrorMessage(item?.controlName) }}</mat-error>
            </mat-form-field>
          </ng-container>


        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
